import {
  convertHalfToFull,
  convertJaSmallToLarge,
} from '../../utils/stringUtil';

interface BankSearchable {
  name: string;
  kana: string;
  hiragana: string;
}

// 金融機関・支店の検索は先頭一致とする。
// 部分一致だと「新宿」の検索で「西新宿」等のノイズが多数並び目的の候補が埋もれるため、
// 中間一致は意図的に対象外（管理画面側の検索は部分一致のまま）
export function matchesBankSearchKeyword(
  target: BankSearchable,
  keyword: string,
): boolean {
  return (
    target.name.startsWith(keyword) ||
    target.name.startsWith(convertHalfToFull(keyword)) ||
    target.kana.startsWith(convertJaSmallToLarge(keyword)) ||
    target.hiragana.startsWith(convertJaSmallToLarge(keyword))
  );
}
